export default "__VITE_ASSET__C9JDFZ9n__"